import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { lockedCheckboxMixin, lockedCheckedCheckboxMixin } from 'modules/core/theme/mixins';

export const ApplyCpoWrapper = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 16px;
  white-space: nowrap;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'default')};
  color: ${({ $disabled }) => ($disabled ? COLORS.GREY_35 : COLORS.BLACK)};
`;

export const Input = styled.input`
  margin-right: 6px;
  cursor: pointer;
  accent-color: ${COLORS.PURPLE_1};
  border-color: ${COLORS.PURPLE_1};

  &:checked {
    background-color: ${COLORS.PURPLE_1};
    border-color: ${COLORS.PURPLE_1};
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: ${COLORS.PURPLE_1};
  }

  &:disabled {
    ${lockedCheckboxMixin}
  }

  &:checked:disabled {
    ${lockedCheckedCheckboxMixin}
  }
`;

export const Label = styled.label<{ disabled?: boolean }>`
  margin: 0;
  font-size: 12px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled }) => (disabled ? COLORS.GREY_35 : COLORS.BLACK)};
  opacity: 1;
`;
